import { useEffect, useMemo } from 'react'

import { useFormField } from '@workwave-tidal/form-fairy'
import { TextField } from '@workwave-tidal/core/components'

import { type FormErrors, type FormFields } from '../../../../../formFields'
import { useTexts } from '../../../../../useTexts'

export function ApiKey() {
  const {
    fieldApi,
    formApi,
    errors,
    field: { value },
  } = useFormField<'credentials', FormFields, FormErrors>('credentials')

  const texts = useTexts()

  const { helperText, error } = useMemo(() => {
    if (errors.length === 0) {
      return {
        helperText: '',
        error: false,
      }
    }

    return {
      helperText: errors[0].message,
      error: true,
    }
  }, [errors])

  useEffect(() => {
    const formStatus = formApi.getMeta().status

    if (formStatus !== 'pristine') {
      fieldApi.validate()
    }
  }, [fieldApi, formApi])

  return (
    <TextField
      name="apiKey"
      size="medium"
      label={texts.azuga.apiKeyLabel}
      value={value.find(field => field.fieldName === 'apiKey')?.value ?? ''}
      error={error}
      onChange={e => {
        fieldApi.change([{ fieldName: 'apiKey', value: e.target.value }])
      }}
      helperText={helperText}
    />
  )
}
